<script setup lang="ts">
import Drawer from '@uiKit/elements/Drawer.vue'
import Text from '@uiKit/elements/Text.vue'
import NotificationsContainer from '../containers/NotificationsContainer.vue'

interface Props {
  open: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <Drawer
    :modelValue="open"
    position="right"
    width="420px"
    @update:modelValue="(v) => !v && emit('close')"
  >
    <template #header>
      <Text type="heading" class="notifications-drawer__title">Notifications</Text>
    </template>
    <NotificationsContainer />
  </Drawer>
</template>

<style scoped>
.notifications-drawer__title {
  flex: 1;
}
</style>
